<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>

        <div class="vx-row mb-3 lg:w-1/2 z-index:999;">
            <div>
                <a href="./schedule"><vs-button color="dark" type="line">외진스케줄</vs-button></a>
                <a href="./walkschedule"><vs-button color="dark" type="line" class="btn btn-sm">산책스케줄</vs-button></a>
                <a href="./healingcenter"><vs-button color="dark" type="line" class="btn btn-sm">힐링센터</vs-button></a>
            </div>
        </div>
        <vx-card title="외진 스케줄" write-toggler @writeClick="popupOpen('', '', '')">
            <div class="vx-row mb-3">
                <div class="vx-col w-full flex items-center schedule-control-wrap">
                    <div class="schedule-date-picker">
                        <date-picker
                            name="uniquenaame"
                            :locale="'ko'"
                            id="now_date"
                            v-model="now_date"
                            class="vs-inputx normal"
                            placeholder="날짜선택"
                            @input="scheduleData(now_date)"
                        ></date-picker>
                    </div>
                    <div class="schedule-btn-group">
                        <vs-button type="border" color="primary" icon-pack="feather" @click="scheduleData('')">오늘</vs-button>
                        <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>
                        <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>
                    </div>
                </div>
            </div>

            <div class="flex justify-end flex-wrap mb-3">
                <vs-button radius color="primary" icon-pack="feather" icon="icon-edit-2" @click="popupOpen('', '')" />
            </div>
        </vx-card>
        <div class="tb_wrap" style="width:100%;overflow:auto;">
            <div id="tb_box_scroll" class="tb_box" style="width:100%;overflow-x:auto;height:auto;">
                <table id="schedule" style="width:100%;min-width:500px;" class="border-collapse calendar">
                    <thead>
                        <tr class="fixed_top">
                            <th class="border border-solid d-theme-border-grey-light text-center table_header" style="width:100px !important; padding:0px 30px!important">시간 / 일</th>
                            <th class="border border-solid d-theme-border-grey-light text-center table_header" style="padding:0px !important">
                                <table width="100%">
                                    <tr>
                                        <td
                                            colspan="2"
                                            :style="
                                                now_date.substring(6, 8) == now_date.substring(6, 8)
                                                    ? 'background-color:#439798 !important; color:#fff;z-index:998;padding:20px;font-size:20px;'
                                                    : 'z-index:999;padding:20px;font-size:20px;'
                                            "
                                        >
                                            {{ dayReturn(now_date) }}
                                            <vs-button color="white" type="flat" size="small" icon-pack="feather" icon="icon-edit-2" @click="popupOpen('', '')" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="padding:20px;width:50%;border-top:1px solid #ccc;background-color:rgba(206,255,211,0.5);font-size:20px;" class="text-left">정규코스</td>
                                        <td style="padding:20px;width:50%;border-top:1px solid #ccc;background-color:rgba(255,238,207,0.5);font-size:20px;" class="text-left">기타코스</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <table width="100%" cellspacing="0">
                                                <tr>
                                                    <th width="80" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">환자명</th>
                                                    <th width="120" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">입원병실</th>
                                                    <th width="100" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">연락처</th>
                                                    <th width="120" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">비고</th>
                                                    <th width="100" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">도착지</th>
                                                    <th width="100" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">-</th>
                                                </tr>
                                            </table>
                                        </td>
                                        <td>
                                            <table width="100%" cellspacing="0">
                                                <tr>
                                                    <th width="50" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">시간</th>
                                                    <th width="80" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">환자명</th>
                                                    <th width="120" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">입원병실</th>
                                                    <th width="100" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">연락처</th>
                                                    <th width="120" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">비고</th>
                                                    <th width="100" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">도착지</th>
                                                    <th width="100" class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">-</th>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index">
                            <th
                                class="border border-solid d-theme-border-grey-light text-center table_header b-table-sticky-column timeHeader"
                                :id="item.CODE_TIME"
                                style="padding:0px!important;height:100%;"
                            >   
                            <!-- 여기에 정규코스, 기타코스 추가버튼 생성 -->
                                <template v-if="item.CODE_TIME == '07'"><span style="font-size:12px;">8시이전</span></template>
                                <template v-else-if="item.CODE_TIME == '19'"><span style="font-size:12px;">18시이후</span></template>
                                <template v-else>
                                    <span style="font-size:12px;">
                                        {{ item.CODE_TIME + '시' }} 
                                    </span>
                                    <div style="text-align: -webkit-center;">
                                        <td style="background-color: #f1f1f1;">
                                            <vx-tooltip text="정규코스 추가">
                                                <vs-button color="primary" type="flat" size="small" icon-pack="feather" icon="icon-toggle-left" @click="coursePopupopen('1', item.CODE_TIME)" />
                                            </vx-tooltip>
                                        </td>
                                        <td style="background-color: #f1f1f1;">
                                            <vx-tooltip text="기타코스 추가">
                                                <vs-button color="primary" type="flat" size="small" icon-pack="feather" icon="icon-toggle-right" @click="coursePopupopen('2', item.CODE_TIME)" />
                                            </vx-tooltip>
                                        </td>
                                    </div>
                                </template>
                                
                                <!-- <table border="0" cellpadding="0" cellspacing="0" width="100%" height="100%">
                                    <tr>
                                        <td style="background-color:#f1f1f1; border-bottom:1px solid #ccc;">{{ item.CODE_TIME }}</td>
                                    </tr>
                                </table> -->
                            </th>
                            <td class="border border-solid d-theme-border-grey-light calendarTD" style="min-width:1200px;height:100px;vertical-align:top;padding:0px !important;">
                                <table border="0" width="100%">
                                    <tr>
                                        <td style="vertical-align: top; width:1800px; padding:0px !important;">
                                            <!-- <vx-card
                                                v-bind:title="'[' + item.CODE_TIME + '시]' + '정규코스'"
                                                card-background="rgba(20,255,75,0.2)"
                                                write-toggler
                                                @writeClick="popupOpenCode(schedule_item, item.CODE_TIME, 1)"
                                            > -->
                                            <!-- 모든 템플릿에 같은 border-collapse 클래스 사용으로 글자크기 밑 div크기가 이 템플릿 stlye값으로 변함 따라서 클래스명 변경 (border-collapse -> borderCollapse) -->
                                            <table class="borderCollapse" width="620">
                                                <!-- <thead>
                                                    <tr>
                                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">환자명</th>
                                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">입원병실</th>
                                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">연락처</th>
                                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">비고</th>
                                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">도착지</th>
                                                        <th class="p-2 border border-solid d-theme-border-grey-light text-center tdHeader" style="">-</th>
                                                    </tr>
                                                </thead> -->
                                                <tbody>
                                                    <tr v-for="(item2, index2) in JSON.parse(calendar_data[index].JSON_DATA)" :key="index2">
                                                        <template v-if="item2.SCHEDULE_GUBUN == 1">
                                                            <td class="text-center" width="80">{{ item2.PATIENT_USERNAME }}</td>
                                                            <td class="text-center" width="120">{{ item2.MEDICAL_ROOM_NUMBER_NM }}-{{ item2.MEDICAL_ROOM_NUMBER_CNT }}</td>
                                                            <td class="text-center" width="100">{{ item2.PATIENT_PHONE }}</td>
                                                            <td class="text-center" width="120">{{ item2.MEMO }}</td>
                                                            <td class="text-center" width="100">
                                                                <template v-if="item2.COMPANY_SCHEDULE_NM == '서울대'">
                                                                    <vs-chip transparent color="danger"> {{ item2.COMPANY_SCHEDULE_NM }} </vs-chip>
                                                                </template>
                                                                <template v-else-if="item2.company_schedule_nm == '세브란스'">
                                                                    <vs-chip transparent color="success"> {{ item2.COMPANY_SCHEDULE_NM }} </vs-chip>
                                                                </template>
                                                                <template v-else>
                                                                    <vs-chip transparent color="primary"> {{ item2.COMPANY_SCHEDULE_NM }} </vs-chip>
                                                                </template>
                                                            </td>
                                                            <td class="text-center" width="100">
                                                                <vs-row vs-type="flex" vs-justify="center">
                                                                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                                                                        <a href="#" @click="popupmodify(item2.SEQ)">
                                                                            <i
                                                                                class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                                                                                style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"
                                                                            ></i>
                                                                        </a>
                                                                        &nbsp;
                                                                        <a href="javascript:void(0)" @click="deleteConfirm(item2.SEQ)">
                                                                            <i
                                                                                class="vs-icon notranslate icon-scale  feather icon-x null"
                                                                                style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"
                                                                            ></i>
                                                                        </a>
                                                                        <a href="javascript:void(0)" @click="deleteAllConfirm(item2.SEQ, now_date)">
                                                                            <i
                                                                                class="vs-icon notranslate icon-scale  feather icon-trash null"
                                                                                style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"
                                                                            ></i>
                                                                        </a>
                                                                    </vs-col>
                                                                </vs-row>
                                                            </td>
                                                        </template>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        <td style="vertical-align: top; width:1400px;padding:0px !important;">
                                            <!-- 모든 템플릿에 같은 border-collapse 클래스 사용으로 글자크기 밑 div크기가 이 템플릿 stlye값으로 변함 따라서 클래스명 변경 (border-collapse -> borderCollapse) -->
                                            <table class="borderCollapse" width="670">
                                                <tbody>
                                                    <tr v-for="(item2, index2) in JSON.parse(calendar_data[index].JSON_DATA)" :key="index2">
                                                        <template v-if="item2.SCHEDULE_GUBUN == 2">
                                                            <td class="text-center" width="50">{{ item2.REALTIME_STRING.substring(0, 2) }}{{ item2.REALTIME_STRING.substring(2, 4) }}</td>
                                                            <td class="text-center" width="80">{{ item2.PATIENT_USERNAME }}</td>
                                                            <td class="text-center" width="120">{{ item2.MEDICAL_ROOM_NUMBER_NM }}-{{ item2.MEDICAL_ROOM_NUMBER_CNT }}</td>
                                                            <td class="text-center" width="100">{{ item2.PATIENT_PHONE }}</td>
                                                            <td class="text-center" width="120">{{ item2.MEMO }}</td>
                                                            <td class="text-center" width="100">
                                                                <vs-chip transparent color="primary"> {{ item2.COMPANY_SCHEDULE_NM }} </vs-chip>
                                                            </td>
                                                            <td class="text-center" width="100">
                                                                <vs-row vs-type="flex" vs-justify="center">
                                                                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                                                                        <a href="#" @click="popupmodify(item2.SEQ)">
                                                                            <i
                                                                                class="vs-icon notranslate icon-scale feather icon-edit-2 null"
                                                                                style="order: 0; margin-right: 0px; margin-left: 0px;color:#015666;"
                                                                            ></i>
                                                                        </a>
                                                                        &nbsp;
                                                                        <a href="javascript:void(0)" @click="deleteConfirm(item2.SEQ)">
                                                                            <i
                                                                                class="vs-icon notranslate icon-scale  feather icon-x null"
                                                                                style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"
                                                                            ></i>
                                                                        </a>
                                                                        <a href="javascript:void(0)" @click="deleteAllConfirm(item2.SEQ, now_date)">
                                                                            <i
                                                                                class="vs-icon notranslate icon-scale  feather icon-trash null"
                                                                                style="order: 0; margin-right: 0px; margin-left: 0px;color:red;"
                                                                            ></i>
                                                                        </a>
                                                                    </vs-col>
                                                                </vs-row>
                                                            </td>
                                                        </template>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <vs-popup title="스케줄 등록 및 수정" :active.sync="popupActive">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-select autocomplete class="w-auto" name="schedule_gubun" v-model="schedule_gubun" @input="schedule_gubunEvent" label="코스" placeholder="코스 선택">
                            <vs-select-item :value="'1'" :text="'정규코스'" />
                            <vs-select-item :value="'2'" :text="'기타코스'" />
                        </vs-select>
                    </div>
                </div>

                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <label for="" class="vs-input--label">시작날짜</label>
                        <date-picker name="schedule_start" :locale="'ko'" v-model="schedule_start" valueType="format" class="vs-inputx normal w-full"></date-picker>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <template v-if="schedule_gubun == '1'">
                            <vs-select autocomplete class="w-auto" name="time" @input="selectTime" v-model="schedule_time" label="시간" placeholder="시간 선택">
                                <vs-select-item v-for="(item, index) in list" :key="index" :value="item.CODE_TIME" :text="item.CODE_TIME + '시'" />
                            </vs-select>
                        </template>
                        <template v-else>
                            <vs-input class="w-full" name="schedule_real_time" v-model="schedule_real_time" label="외진예정시간(hhmm)" placeholder="외진예정시간(hhmm)" />
                        </template>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-select autocomplete class="w-auto" name="time" v-model="schedule_company" label="도착지" placeholder="도착지 선택">
                            <vs-select-item v-for="(item, index) in company_list" :key="index" :value="item.COMPANY_SCHEDULE_CD" :text="item.COMPANY_SCHEDULE_NM" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1">
                        <v-select :maxHeight="'50px'" ref="searchInputNew" v-model="schedule_member" :closeOnSelect="true" :options="member_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" @open="resetOption()"/>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-input class="w-full" name="memo" v-model="schedule_memo" label="비고" placeholder="비고" />
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-checkbox :vs-value="'true'" v-model="autoCheck" @input="autoEvent">반복설정 여부</vs-checkbox>
                    </div>
                </div>

                <template v-if="autoCheck == 'true'">
                    <div class="vx-col w-full lg:w-1/1 mb-base">
                        <hr />
                    </div>

                    <div class="vx-col w-full lg:w-1/1 mb-base">
                        <h5>반복설정</h5>
                    </div>

                    <div class="vx-col w-full lg:w-1/2 mb-base">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-select autocomplete class="w-auto" name="schedule_gubun" v-model="schedule_gubun_type" label="주기옵션" placeholder="주기선택">
                                <vs-select-item :value="1" :text="'일'" />
                                <vs-select-item :value="2" :text="'주'" />
                                <vs-select-item :value="3" :text="'개월'" />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-col w-full lg:w-1/2 mb-base">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-input class="w-full" name="memo" v-model="schedule_gubun_number" label="주기" placeholder="" />
                        </div>
                    </div>

                    <div class="vx-col w-full lg:w-1/1 mb-base" v-if="schedule_gubun_type == '2'">
                        <ul class="centerx">
                            <li>
                                <vs-checkbox :vs-value="'1'" v-model="schedule_week">월</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'2'" v-model="schedule_week">화</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'4'" v-model="schedule_week">수</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'8'" v-model="schedule_week">목</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'16'" v-model="schedule_week">금</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'32'" v-model="schedule_week">토</vs-checkbox>
                            </li>
                            <li>
                                <vs-checkbox :vs-value="'64'" v-model="schedule_week">일</vs-checkbox>
                            </li>
                        </ul>
                    </div>
                    <div class="vx-col w-full lg:w-1/1 mb-base" v-if="schedule_gubun_type == '3'">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-select autocomplete class="w-auto" name="schedule_gubun_day" label="매월(일)주기" v-model="schedule_gubun_days" placeholder="매월(일)주기 선택">
                                <vs-select-item v-for="index in 31" :key="index" :value="index" :text="index + '일'" />
                            </vs-select>
                        </div>
                    </div>
                    <div class="vx-col w-full lg:w-1/1 mb-base">
                        <div class="vx-col w-full lg:w-1/1 ">
                            <vs-radio vs-value="N" v-model="schdule_endYN">없음</vs-radio>
                        </div>
                        <div class="vx-col w-full lg:w-1/1 ">
                            <ul class="centerx">
                                <li>
                                    <vs-radio vs-value="Y" v-model="schdule_endYN">종료날짜</vs-radio>
                                </li>
                                <li style="padding-left:20px;">
                                    <date-picker name="patientBirthday" :locale="'ko'" v-model="schedule_end" valueType="format" class="vs-inputx normal w-full"></date-picker>
                                </li>
                            </ul>
                        </div>
                        <div class="vx-col w-full lg:w-1/1 "></div>
                    </div>
                </template>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full text-right ">
                    <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="button">
                        <span @click="messageScheduleSave">저장</span>
                    </button>
                    <button class="vs-component vs-button mb-2 vs-button-warning vs-button-border" type="button">
                        <span @click="popupActive = false">닫기</span>
                    </button>

                    <!-- <vs-button class="mr-3 mb-2" @click="messageScheduleSave">저장</vs-button> -->
                    <!-- <vs-button color="warning" type="border" class="mb-2" @click="popupActive = false">닫기</vs-button> -->
                </div>
            </div>
        </vs-popup>

        <vs-popup title="스케줄 등록 및 수정" :active.sync="popupActiveModify">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-select autocomplete class="w-auto" name="schedule_gubun" v-model="schedule_gubun" @input="schedule_gubunEvent" label="코스" placeholder="코스 선택">
                            <vs-select-item :value="'1'" :text="'정규코스'" />
                            <vs-select-item :value="'2'" :text="'기타코스'" />
                        </vs-select>
                    </div>
                </div>

                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <label for="" class="vs-input--label">시작날짜</label>
                        <date-picker name="schedule_start" :locale="'ko'" v-model="schedule_start" valueType="format" class="vs-inputx normal w-full"></date-picker>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <template v-if="schedule_gubun == '1'">
                            <vs-select autocomplete class="w-auto" name="time" @input="selectTime" v-model="schedule_time" label="시간" placeholder="시간 선택">
                                <vs-select-item v-for="(item, index) in list" :key="index" :value="item.CODE_TIME" :text="item.CODE_TIME + '시'" />
                            </vs-select>
                        </template>
                        <template v-else-if="schedule_gubun == '2'">
                            <vs-input class="w-full" name="schedule_real_time" v-model="schedule_real_time" label="외진예정시간(hhmm)" placeholder="외진예정시간(hhmm)" />
                        </template>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/3 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-select autocomplete class="w-auto" name="time" v-model="schedule_company" label="도착지" placeholder="도착지 선택">
                            <vs-select-item v-for="(item, index) in company_list" :key="index" :value="item.COMPANY_SCHEDULE_CD" :text="item.COMPANY_SCHEDULE_NM" />
                        </vs-select>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1">
                        <v-select :maxHeight="'50px'" ref="searchInputModify" v-model="schedule_member" :closeOnSelect="true" :options="member_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" @open="resetOption()"/>
                    </div>
                </div>
                
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-input class="w-full" name="memo" v-model="schedule_memo" label="비고" placeholder="비고" />
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full text-right ">
                    <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="button">
                        <span class="mr-3 mb-2" @click="messageScheduleModify">저장</span>
                    </button>
                    <button class="vs-component vs-button mb-2 vs-button-warning vs-button-border" type="button">
                        <span color="warning" @click="popupActiveModify = false">닫기</span>
                    </button>

                    <!-- <vs-button class="mr-3 mb-2" @click="messageScheduleModify">저장</vs-button> -->
                    <!-- <vs-button color="warning" type="border" class="mb-2" @click="popupActiveModify = false">닫기</vs-button> -->
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import moment from 'moment';
import vSelect from 'vue-select';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: {
        DatePicker,
        'v-select': vSelect,
    },
    data() {
        return {
            now_date: '',
            prev_date: '',
            next_date: '',
            list: [],
            now_day: '',
            date_list: [],
            calendar_data: [],
            company_list: [],
            company_list_tmp: [],
            popupActive: false,
            popupActiveModify: false,
            search: '',
            schdule_endYN: 'N',
            schedule_start: '',
            schedule_end: '',
            schedule_time: '',
            schedule_real_time: '',
            schedule_gubun: '',
            schedule_company: '',
            schedule_member: '',
            schedule_week: [],
            schedule_gubun_number: 1,
            schedule_gubun_type: 0,
            schedule_gubun_days: 0,
            member_list: [],
            selected_seq: -1,
            selected_schedule_code: '',
            autoCheck: null,
            schedule_memo: '',
            start_date: '',
            end_date: '',
            width: window.innerWidth,
            height: 2014,
            hospitalList: ['세브란스', '서울대', '강남세브란스', '신촌세브란스','서울대', '이대목동', '강북삼성', '아산병원'
                        , '서울삼성', '여의도성모', '임센터', '은평성모', '구로고대', '강남성모', '한양대', '순천향', '강남성심', '건국대'
                        , '인천성모', '경희대병원', '일산병원', '평촌한림', '안암고대', '기타의원', '명지성모', '기타병원', '군포지샘병원'
                        , '일산암센터', '기타', '강북삼성', '이대서울'],
            prevScheduleData: '',
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        },
        prevMonth() {
            console.log(this.now_date);
            this.prev_date = dateClass.prevYYYYMMDD2(this.now_date);
            this.scheduleData(this.prev_date);
        },
        nextMonth() {
            // this.now_date = this.next_date;
            this.next_date = dateClass.nextYYYYMMDD2(this.now_date);
            this.scheduleData(this.next_date);
        },
        async scheduleData(date) {
            this.w_with = window.innerWidth;
            console.log('width:' + this.w_with);
            this.now_date = dateClass.getDate('YYYY-MM-DD');

            if (date == '') {
                this.now_date = dateClass.dateYYYYMMDD();
            } else {
                this.now_date = moment(date).format('YYYYMMDD');
            }

            this.prev_date = dateClass.prevYYYYMM(this.now_date.substring(0, 6));
            this.next_date = dateClass.nextYYYYMM(this.now_date.substring(0, 6));
            this.$vs.loading({
                type: 'default',
                container: '#schedule',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            const { data } = await axiosClass.get('/api/message/list/' + this.now_date.substring(0, 8), {}, true);
            this.member_list = JSON.parse(data.memberList);
            this.list = data.schedule_data;

            // 2023-05-19 정규코스 선택시 시간데이터가 온전히 나오지 않아 주석처리
            // if (this.schedule_gubun == 1) {
            //     // console.info('정규코스');
            //     // 7시,12시,18시,19시 삭제
            //     for (let i = 0; i < this.list.length; i++) {
            //         if (this.list[i].CODE_TIME == '07' || this.list[i].CODE_TIME == '12' || this.list[i].CODE_TIME == '18' || this.list[i].CODE_TIME == '19') {
            //             this.list.splice(i, 1);
            //         }
            //     }
            // } else {
            //     // console.info('기타코스');
            // }
            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
            this.calendar_data = data.schedule_data;
        },

        dayReturn(item) {
            const week = ['일', '월', '화', '수', '목', '금', '토'];
            const weekString = week[new Date(item.substring(0, 4) + '-' + item.substring(4, 6) + '-' + item.substring(6, 8)).getDay()];
            return parseInt(item.substring(4, 6)) + '월 / ' + parseInt(item.substring(6, 8)) + '일(' + weekString + ')';
        },

        autoEvent() {
            console.log(this.autoCheck);
        },

        async popupmodify(schedule_seq) {
            console.log(schedule_seq);
            this.selected_seq = schedule_seq;
            this.popupActiveModify = true;

            const { data } = await axiosClass.get('/api/message/select/' + this.selected_seq, {}, true);
            this.schedule_gubun = data.selectData.SCHEDULE_GUBUN;

            this.schedule_start = data.selectData.START_YMD.substring(0, 4) + '-' + data.selectData.START_YMD.substring(4, 6) + '-' + data.selectData.START_YMD.substring(6, 10);
            if (data.selectData.SCHEDULE_GUBUN == 1) {
                this.schedule_time = data.selectData.TIMESTRING;
            } else {
                this.schedule_real_time = data.selectData.REALTIME_STRING;
            }

            await this.selectTime();
            this.schedule_company = data.selectData.COMPANY_SCHDULE_CD;
            for (let i = 0; i < this.member_list.length; i++) {
                if (this.member_list[i].id == data.selectData.PATIENT_UID) {
                    this.schedule_member = this.member_list[i];
                    break;
                }
            }
            // this.schedule_member = {
            //     id: data.selectData.PATIENT_UID,
            // };
            this.schedule_memo = data.selectData.MEMO;
            this.prevScheduleData = data.selectData;
        },

        async schedule_gubunEvent() {
            const params = {
                ymd: this.now_date,
            };
            if (this.schedule_gubun == '') {
            } else {
                const { data } = await axiosClass.get('/api/message/company/' + this.schedule_gubun, params, true);
                // if(parseInt(this.schedule_time)
                this.company_list = data.company_list;
                this.list = data.schedule_data;
                // 2023-05-19 정규코스 선택시 시간데이터가 온전히 나오지 않아 주석처리
                // if (this.schedule_gubun == 1) {
                //     console.info('정규코스');
                //     // 7시,12시,18시,19시 삭제
                //     for (let i = 0; i < this.list.length; i++) {
                //         if (this.list[i].CODE_TIME == '07' || this.list[i].CODE_TIME == '12' || this.list[i].CODE_TIME == '18' || this.list[i].CODE_TIME == '19') {
                //             this.list.splice(i, 1);
                //         }
                //     }
                // } else {
                //     console.info('기타코스');
                // }

                console.log(this.list);
            }
        },

        async selectTime() {
            this.schedule_company = '';
            const { data } = await axiosClass.get('/api/message/company/' + this.schedule_gubun, {}, true);
            // if(parseInt(this.schedule_time)
            this.company_list = data.company_list;

            if (this.schedule_gubun == 1) {
                // if (this.schedule_time == '09' || this.schedule_time == '14' || this.schedule_time == '16'
                if (this.schedule_time == '17') {
                    for (let i = 0; i < this.company_list.length; i++) {
                        if (this.company_list[i].COMPANY_SCHEDULE_CD == 2) {
                            this.company_list.splice(i, 1);
                        }
                    }
                }

                // if (this.schedule_time != '08' && this.schedule_time != '10' && this.schedule_time != '13' && this.schedule_time != '15') {
                //     for (let i = 0; i < this.company_list.length; i++) {
                //         if (this.company_list[i].COMPANY_SCHEDULE_CD == 30) {
                //             this.company_list.splice(i, 1);
                //         }
                //     }
                // }

                // 8시,10시,13시,15시 강북삼성 삭제
                if (
                    this.schedule_time == '08' ||
                    this.schedule_time == '10' ||
                    this.schedule_time == '11' ||
                    this.schedule_time == '14' ||
                    this.schedule_time == '13' ||
                    this.schedule_time == '15' ||
                    this.schedule_time == '16' ||
                    this.schedule_time == '17' 
                ) {
                    for (let i = 0; i < this.company_list.length; i++) {
                        if (this.company_list[i].COMPANY_SCHEDULE_CD == 30) {
                            this.company_list.splice(i, 1);
                        }
                    }
                }
            }
        },

        async memberSearch() {
            const { data } = await axiosClass.get('/api/message/member', { search: this.search }, true);
            this.member_list = data.member_list;
            console.log(data);
        },

        async popupOpen() {
            console.log('open');
            this.autoCheck = null;
            this.schdule_endYN = 'N';
            this.schedule_start = dateClass.dateYYYYMMDD3(this.now_date);
            this.schedule_end = '';
            this.schedule_time = '';
            this.schedule_real_time = '';
            this.schedule_gubun = '';
            this.schedule_company = '';
            this.schedule_member = '';
            this.schedule_week = [];
            this.schedule_gubun_number = 1;
            this.schedule_gubun_type = 0;
            this.schedule_gubun_days = 0;
            this.schedule_memo = '';
            this.popupActive = true;
        },

        async coursePopupopen(defaultScheduleGubun, time) {
            this.autoCheck = null;
            this.schdule_endYN = 'N';
            this.schedule_start = dateClass.dateYYYYMMDD3(this.now_date);
            this.schedule_end = '';
            this.schedule_time = time;
            this.schedule_real_time = time+"00";
            this.schedule_gubun = defaultScheduleGubun;
            await this.schedule_gubunEvent();
            this.schedule_company = '';
            this.schedule_member = '';
            this.schedule_week = [];
            this.schedule_gubun_number = 1;
            this.schedule_gubun_type = 0;
            this.schedule_gubun_days = 0;
            this.schedule_memo = '';
            this.popupActive = true;
        },

        async deleteConfirm(seq) {
            this.selected_seq = seq;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택하신 외진 스케줄 개별삭제를 하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: this.deleteConfirmProcess,
            });
        },
        async deleteConfirmProcess() {
            
            const { data } = await axiosClass.get('/api/message/select/' + this.selected_seq, {}, true);
            this.schedule_gubun = data.selectData.SCHEDULE_GUBUN;
            
            this.schedule_start = data.selectData.START_YMD.substring(0, 4) + '-' + data.selectData.START_YMD.substring(4, 6) + '-' + data.selectData.START_YMD.substring(6, 10);
            if (data.selectData.SCHEDULE_GUBUN == 1) {
                this.schedule_time = data.selectData.TIMESTRING;
            } else {
                this.schedule_real_time = data.selectData.REALTIME_STRING;
            }
            
            await this.selectTime();
            this.schedule_company = data.selectData.COMPANY_SCHDULE_CD;
            for (let i = 0; i < this.member_list.length; i++) {
                if (this.member_list[i].id == data.selectData.PATIENT_UID) {
                    this.schedule_member = this.member_list[i];
                    break;
                }
            }
            
            this.schedule_memo = data.selectData.MEMO;
            this.prevScheduleData = data.selectData;
            
            if(this.schedule_start == dateClass.getDate('YYYY-MM-DD')) {
                await this.sendKakaoWorkBot('delete');
            }

            const jsonData = {
                seq: this.selected_seq,
            };
            await axiosClass.delete('/api/message/one', jsonData, true);

            this.$vs.notify({
                color: 'danger',
                title: '삭제 완료',
                text: '삭제가 완료되었습니다.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            await this.scheduleData(this.now_date);
        },

        async deleteAllConfirm(schedule_seq, now_date) {
            this.selected_schedule_code = schedule_seq;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '선택하신 외진 스케줄 전체삭제 하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: this.deleteConfirmAllProcess,
            });
        },

        async deleteConfirmAllProcess() {
            
            const { data } = await axiosClass.get('/api/message/select/' + this.selected_schedule_code, {}, true);
            this.schedule_gubun = data.selectData.SCHEDULE_GUBUN;
            
            this.schedule_start = data.selectData.START_YMD.substring(0, 4) + '-' + data.selectData.START_YMD.substring(4, 6) + '-' + data.selectData.START_YMD.substring(6, 10);
            if (data.selectData.SCHEDULE_GUBUN == 1) {
                this.schedule_time = data.selectData.TIMESTRING;
            } else {
                this.schedule_real_time = data.selectData.REALTIME_STRING;
            }

            await this.selectTime();
            this.schedule_company = data.selectData.COMPANY_SCHDULE_CD;
            for (let i = 0; i < this.member_list.length; i++) {
                if (this.member_list[i].id == data.selectData.PATIENT_UID) {
                    this.schedule_member = this.member_list[i];
                    break;
                }
            }
            
            this.schedule_memo = data.selectData.MEMO;
            this.prevScheduleData = data.selectData;

            if(this.schedule_start == dateClass.getDate('YYYY-MM-DD')) {
                await this.sendKakaoWorkBot('delete');
            }
            const jsonData = {
                schedule_code: this.selected_schedule_code,
                now_date: this.now_date,
            };

            await axiosClass.delete('/api/message/all', jsonData, true);
            this.$vs.notify({
                color: 'danger',
                title: '삭제 완료',
                text: '삭제가 완료되었습니다.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
            await this.scheduleData(this.now_date);
        },

        async popupOpenCode(date, time, code) {
            this.schdule_endYN = 'N';
            this.schedule_start = '';
            this.schedule_end = '';
            this.schedule_time = '';
            this.schedule_gubun = '';
            this.schedule_company = '';
            this.schedule_member = '';
            this.schedule_week = [];
            this.schedule_gubun_number = 1;
            this.schedule_gubun_type = 0;
            this.schedule_gubun_days = 0;

            this.popupActive = true;
            this.schedule_gubun = code;
            await this.schedule_gubunEvent();
            this.schedule_start = moment(date).format('YYYY-MM-DD');
            this.schedule_time = time;
            await this.selectTime();
            console.log(date);
            console.log(moment(date).format('YYYY-mm-dd'));
        },

        async messageScheduleModify() {
            let err_msg = '';
            let week_sum = 0;
            if (this.schedule_gubun == false) {
                err_msg = '코스를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            if (this.schedule_start == false) {
                err_msg = '시작날짜를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            if (this.schedule_gubun == '1') {
                if (this.schedule_time == false) {
                    err_msg = '시간을 선택해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }
            }

            if (this.schedule_gubun == '2') {
                if (this.schedule_real_time == false) {
                    err_msg = '시간을 입력해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }
            }

            if (this.schedule_company == false) {
                err_msg = '도착지를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            if (this.schedule_member.id == false) {
                err_msg = '환자를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            const jsonData = {
                selected_seq: this.selected_seq,
                schedule_gubun: this.schedule_gubun,
                schedule_start: this.schedule_start,
                schedule_time: this.schedule_time,
                schedule_real_time: this.schedule_real_time,
                schedule_company: this.schedule_company,
                schedule_member: this.schedule_member.id,
                schedule_memo: this.schedule_memo,
                now_date: this.now_date,
            };

            await axiosClass.post('/api/message/modify', jsonData);

            if(this.schedule_start == dateClass.getDate('YYYY-MM-DD')) {
                await this.sendKakaoWorkBot('modify');
            }

            this.popupActiveModify = false;

            await this.scheduleData(this.now_date);
        },

        async messageScheduleSave() {
            let err_msg = '';
            let week_sum = 0;
            if (this.schedule_gubun == false) {
                err_msg = '코스를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }
            if (this.schedule_start == false) {
                err_msg = '시작날짜를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            if (this.schedule_gubun == '1') {
                if (this.schedule_time == false) {
                    err_msg = '시간을 선택해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }
            }

            if (this.schedule_gubun == '2') {
                if (this.schedule_real_time == false) {
                    err_msg = '시간을 입력해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }
            }

            if (this.schedule_company == false) {
                err_msg = '도착지를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            if (this.schedule_member.id == false) {
                err_msg = '환자를 선택해주세요.';
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    text: err_msg,
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            if (this.autoCheck == 'true') {
                if (this.schedule_gubun_number == false) {
                    err_msg = '주기를 입력해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }

                if (this.schedule_gubun_type == false) {
                    err_msg = '주기옵션을 선택해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
                }

                if (this.schedule_gubun_type == '2') {
                    if (this.schedule_week.length == 0) {
                        err_msg = '요일을 선택해주세요.';
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            text: err_msg,
                            position: 'top-right',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        return;
                    } else {
                        for (let i = 0; i < this.schedule_week.length; i++) {
                            week_sum = parseInt(week_sum) + parseInt(this.schedule_week[i]);
                        }
                    }
                } else if (this.schedule_gubun_type == '3') {
                    if (this.schedule_gubun_days == 0) {
                        err_msg = '매월(일)주기를 선택해주세요.';
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            text: err_msg,
                            position: 'top-right',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        return;
                    }
                }

                if (this.schdule_endYN == 'Y') {
                    if (this.schedule_end == false) {
                        err_msg = '종료날짜를 선택해주세요.';
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            text: err_msg,
                            position: 'top-right',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                        });
                        return;
                    }
                }
            }

            const jsonData = {
                schedule_gubun: this.schedule_gubun,
                schedule_start: this.schedule_start,
                schedule_end: this.schedule_end,
                schedule_time: this.schedule_time,
                schedule_real_time: this.schedule_real_time,
                schedule_company: this.schedule_company,
                schedule_member: this.schedule_member.id,
                schedule_gubun_number: this.schedule_gubun_number,
                schedule_gubun_type: this.schedule_gubun_type,
                schedule_gubun_days: this.schedule_gubun_days,
                schedule_memo: this.schedule_memo,
                schedule_week: week_sum,
                authCheck: this.autoCheck,
                schdule_endYN: this.schdule_endYN,
                now_date: this.now_date,
            };

            await axiosClass.post('/api/message/save', jsonData);

            // 20230427 TH 추가
            // 외진 알림봇으로 외진 스케쥴 전송
            

            if (this.schedule_start == this.customFormatter(this.now_date)) {
                
                await this.sendKakaoWorkBot('new');
            }

            this.popupActive = false;

            await this.scheduleData(this.now_date);
        },

        async scheduleGubunDaysChange() {},
        backgroundColor() {
            var x = Math.floor(Math.random() * 256);
            var y = Math.floor(Math.random() * 256);
            var z = Math.floor(Math.random() * 256);
            var bgColor = 'rgb(' + x + ',' + y + ',' + z + ')';
            console.log('OK');

            return 'background-color:' + bgColor + '; color:#fff;';
        },
        // 20230427 TH 추가

        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        // 20230427 TH 추가
        // 외진 알림봇으로 외진 스케쥴 전송
        async sendKakaoWorkBot(driveScheduleDistinguish) {
            // 환자 ID 유효성 검사
            if (!this.schedule_member.id || this.schedule_member.id === 'undefined' || this.schedule_member.id === undefined) {
                console.warn('[message/Schedule] schedule_member.id is undefined, skipping API call');
                this.$vs.notify({
                    color: 'danger',
                    title: '오류',
                    text: '환자 정보를 확인해주세요.',
                    position: 'top-right',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                return;
            }

            const massData = await axiosClass.get('/api/patient/view/'+this.schedule_member.id, {}, true);
            console.log(massData.data.memberData);
            const patientData = massData.data.memberData
            if (patientData.PATIENT_USERNAME == null || patientData.PATIENT_USERNAME == undefined) {
                    err_msg = '환자를 확인해주세요.';
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        text: err_msg,
                        position: 'top-right',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    return;
            }
            
            let scheduleTimeText = '';
            let prevScheduleTimeText = '';
            
            if (this.schedule_gubun == 1) {
                scheduleTimeText = this.schedule_time + '시';
            } else {
                if(this.schedule_real_time.substring(2,4) == '00') {
                    scheduleTimeText = this.schedule_real_time.substring(0,2) + '시';
                } else {
                    scheduleTimeText = this.schedule_real_time.substring(0,2) + '시' + this.schedule_real_time.substring(2,4) + '분';
                }
            }

            let msgText = '';
            let patientRoom = patientData.MEDICAL_ROOM_NUMBER_NM == '' ? '' : patientData.MEDICAL_ROOM_NUMBER_NM;
            let patientBed = patientData.MEDICAL_ROOM_NUMBER_CNT == '' ? '' : '-' + patientData.MEDICAL_ROOM_NUMBER_CNT;
            let patientRoomAndBed = patientRoom + patientBed;

            if (driveScheduleDistinguish == 'new') {
                msgText = patientRoomAndBed + ' '
                + patientData.PATIENT_USERNAME + '님 금일 ' + scheduleTimeText + ', ' + this.hospitalList[this.schedule_company-1] + ' 차량신청 하셨습니다.';
            } else if (driveScheduleDistinguish == 'modify') {

                // console.log(this.prevScheduleData);
                
                if (this.prevScheduleData.SCHEDULE_GUBUN == 1) {
                    prevScheduleTimeText = this.prevScheduleData.TIMESTRING + '시';
                } else {
                    if(this.prevScheduleData.REALTIME_STRING.substring(2,4) == '00') {
                        prevScheduleTimeText = this.prevScheduleData.REALTIME_STRING.substring(0,2) + '시';
                    } else {
                        prevScheduleTimeText = this.prevScheduleData.REALTIME_STRING.substring(0,2) + '시' + this.prevScheduleData.REALTIME_STRING.substring(2,4) + '분';
                    }
                }

                msgText = patientRoomAndBed + ' '
                + patientData.PATIENT_USERNAME + '님 금일 ' + prevScheduleTimeText + ', ' + this.hospitalList[this.prevScheduleData.COMPANY_SCHDULE_CD - 1] + ' 차량 -> ' 
                + scheduleTimeText + ', ' + this.hospitalList[this.schedule_company-1] + '(으)로 변경하셨습니다.';

            } else if (driveScheduleDistinguish == 'delete'){
                msgText = patientRoomAndBed + ' '
                + patientData.PATIENT_USERNAME + '님 금일 ' + scheduleTimeText + ', ' + this.hospitalList[this.schedule_company-1] + ' 차량 취소 하셨습니다.';
            }

            let driveScheduleData = {
                    conversationId : 6174107, // 대표원장님, 행정원장님, 관리팀장, 전산주임이 초대된 외진알림방의 id
                    // conversationId : 6172780, // 개발주임만 있는 방 id for test(외진스케쥴탭)
                    msgText : msgText,
                    fromWhere : 2 // 외진스케쥴일때
                }
            // console.log(driveScheduleData);
            const response = await axiosClass.post('/api/kakaoWork/sendMessages', driveScheduleData, true);
            console.log(response);
        },
        async searchPatient (value) {
            this.member_list = [];

            let params = {
                search_name : value
            }

            if(value != ''){
                const { data } = await axiosClass.get(
                    "/api/patient/search_patientList",
                    params,
                    true
                );
                for (let i = 0; i < data.data.length; i++) {
                    this.member_list.push({
                        id: data.data[i].PATIENT_UID,
                        patientPhone : data.data[i].PATIENT_PHONE,
                        patientName : data.data[i].PATIENT_USERNAME,
                        patientUid : data.data[i].PATIENT_UID,
                        oxygenPoint : data.data[i].OXYGEN_POINT || 0,
                        label: (data.data[i].MEDICAL_ROOM_NM != '' ? data.data[i].MEDICAL_ROOM_NM + '-' + data.data[i].MEDICAL_ROOM_NUMBER_NM + ' : ' : '') + data.data[i].CHART_NO + '/' + data.data[i].PATIENT_USERNAME + '('+ data.data[i].PATIENT_PHONE.substr(9,4) + ')',
                    });
                }
            }

        },
        resetOption () {
            this.member_list=[];
        }
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.scheduleData('');
        this.$nextTick(() => {
            const newInput = this.$refs.searchInputNew && this.$refs.searchInputNew.$el.querySelector("input");
            const modifyInput = this.$refs.searchInputModify && this.$refs.searchInputModify.$el.querySelector("input");
            
            if (newInput) {
                console.log("New input found");
                newInput.addEventListener("keyup", (event) => {
                    if (event.key === "Enter") {
                        this.searchPatient(newInput.value);
                    }
                });
            }
            
            if (modifyInput) {
                console.log("Modify input found");
                modifyInput.addEventListener("keyup", (event) => {
                    if (event.key === "Enter") {
                        this.searchPatient(modifyInput.value);
                    }
                });
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {
        nowDate() {
            return this.now_date.substring(0, 4) + '년 ' + this.now_date.substring(4, 6) + '월';
        },
        
    },
};
</script>

<style>
.calendar tbody tr td {
    padding: 10px !important;
}

.includeIcon {
    display: initial;
}

.con-vs-chip {
    min-height: 40px;
}

.vs-chip--text {
    font-size: 11px;
}

.activeMenu {
    border-color: #015666;
}

.display-time {
    padding: 0.7rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
}

.tb_box {
    height: 750px;
    overflow: auto;
}
.table_header {
    position: sticky;
    top: 0;
    z-index: 1000;
}

.selectOn {
    border: 3px solid #439798;
    color: #fff;
}

.selectOff {
    border: 0px;
    color: #fff;
}

.mx-datepicker-popup {
    z-index: 90000000 !important;
}
.activeMenu {
    border-color: #015666;
}
.tb_box {
    height: 630px;
    overflow: auto;
}
.centerx {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.calendarTD .vx-card__body {
    padding: 0px !important;
}

.calendarTD .vx-card__header .vx-card__title h4 {
    font-size: 14px;
}

.calendarTD .vx-card__header {
    padding: 10px;
}

.calendar tbody tr td {
    padding: 5px !important;
    font-size: 11px;
    background-color: #fff;
}

.con-vs-chip {
    float: none !important;
    min-height: 25px !important;
}

.timeHeader {
    position: sticky;
    left: 0;
    z-index: 999;
}

.cTitle {
    padding: 20px;
    width: 100%;
    background-color: #ccc;
}
.tdHeader {
    background-color: #f1f1f1;
}

.borderCollapse i {
    font-size: 10px;
}

.borderCollapse .includeIconOnly {
    width: 24px !important;
    height: 24px !important;
}
#tb_box_scroll::-webkit-scrollbar {
  display: none;
}

/* Schedule control layout fix */
.schedule-control-wrap {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 10px;
}

.schedule-date-picker {
    flex-shrink: 0;
    width: 180px;
}

.schedule-date-picker .mx-datepicker {
    width: 100% !important;
}

.schedule-btn-group {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 5px;
}

.schedule-btn-group .vs-button {
    margin: 0 !important;
    flex-shrink: 0;
}

/* Mobile responsive */
@media (max-width: 576px) {
    .schedule-control-wrap {
        flex-wrap: wrap;
    }

    .schedule-date-picker {
        width: 100%;
        margin-bottom: 10px;
    }

    .schedule-btn-group {
        width: 100%;
        justify-content: flex-start;
    }
}

</style>
